import React, { useContext, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle as MuiDialogTitle,
  DialogActions,
  Fade,
  IconButton,
  Typography,
  Tooltip,
  Grow,
  CircularProgress,
} from '@material-ui/core';
import { fade, makeStyles } from '@material-ui/core/styles';
import ClaimWizard from './ClaimWizard';
import { ClaimContext, transitionTimeout } from '../../../contexts/ClaimContext';
import { ArrowBack, ArrowForward, Close, Done } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { Fragment } from 'react';
import LimitedBackdrop from '../../../components/UI/LimitedBackdrop';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    // top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <Tooltip title={'Cerrar'} enterDelay={1000}>
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <Close />
          </IconButton>
        </Tooltip>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles(theme => ({
  dialog: {
    position: 'absolute',
    width: '80vw',
    height: '40em',
    transition: '.3s',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  finish: {
    transition: '.7s cubic-bezier(0.15, 0.74, 0.63, 1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 400,
    height: 200,
    backgroundColor: theme.palette.primary.main,
  },
  finishContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: fade('#FFF', 0.7),
    padding: theme.spacing(1),
  },
  closeButton: {
    transition: '.2s !important',
    position: 'absolute',
    top: 0,
    right: 0,
    color: fade('#FFF', 0.3),
    '&:hover': {
      backgroundColor: 'transparent',
      color: fade('#FFF', 0.5),
    },
  },
}));

const SuccessDialogBody = ({ onClose }) => {
  const classes = useStyles();
  const [closeFinish, setCloseFinish] = useState(false);

  return (
    <Fragment>
      <Fade in={closeFinish} timeout={700}>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      </Fade>
      <Grow
        in={true}
        timeout={700}
        style={{ transitionDelay: 300 }}
        onEntered={() => {
          setCloseFinish(true);
        }}>
        <div className={classes.finishContent}>
          <Typography align="center" variant="h5">
            Reclamo enviado con éxito
          </Typography>
        </div>
      </Grow>
    </Fragment>
  );
};

const NewClaimModal = ({ open, setOpen, reloadGrid }) => {
  const classes = useStyles();
  const { currentStep, steps, stepBack, stepForward, clearSteps, finish, finishAndExit, openBackDrop } = useContext(ClaimContext);

  const onClose = () => {
    setOpen(false);
    finish && reloadGrid();
    setTimeout(() => {
      clearSteps();
    }, 500);
  };

  return (
    <Dialog
      classes={{ paper: clsx(classes.dialog, { [classes.finish]: finish }) }}
      disableBackdropClick={!finish}
      maxWidth="xl"
      open={open}
      onClose={onClose}>
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      {finish ? (
        <SuccessDialogBody onClose={onClose} />
      ) : (
        <Fragment>
          <DialogTitle id="customized-dialog-title" onClose={onClose}>
            Nuevo Reclamo
          </DialogTitle>
          <DialogContent style={{ overflowX: 'hidden' }} dividers>
            <ClaimWizard />
          </DialogContent>
          {currentStep !== 0 && (
            <DialogActions>
              <div className={classes.footer}>
                {currentStep !== 0 && (
                  <Fade in={true} timeout={500}>
                    <Button color="secondary" startIcon={<ArrowBack />} onClick={() => stepBack(currentStep)}>
                      {steps[currentStep]?.backButtonText}
                    </Button>
                  </Fade>
                )}
                {steps[currentStep]?.nextButtonText && (
                  <Fade in={true} timeout={500}>
                    <Button color="primary" endIcon={<ArrowForward />} onClick={steps[currentStep].nextButtonAction || stepForward}>
                      {steps[currentStep].nextButtonText}
                    </Button>
                  </Fade>
                )}
                {steps[currentStep]?.finishButtonText && (
                  <Fade in={true} timeout={500}>
                    <Button
                      color="primary"
                      endIcon={<Done />}
                      onClick={() => {
                        steps[currentStep]
                          .finishButtonAction()
                          .then(res => {
                            steps[currentStep].transition.exit();
                            setTimeout(() => finishAndExit(), transitionTimeout);
                          })
                          .catch(error => {});
                      }}>
                      {steps[currentStep].finishButtonText}
                    </Button>
                  </Fade>
                )}
              </div>
            </DialogActions>
          )}
        </Fragment>
      )}
    </Dialog>
  );
};

export default NewClaimModal;
